import { render } from "./DailyReview.vue?vue&type=template&id=1d657cd6&scoped=true"
import script from "./DailyReview.vue?vue&type=script&lang=js"
export * from "./DailyReview.vue?vue&type=script&lang=js"

import "./DailyReview.vue?vue&type=style&index=0&id=1d657cd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d657cd6"]])

export default __exports__